import { Injectable } from '@angular/core';
import {
    HttpClient, HttpParams,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { SettlementProcess } from '../_models/settlementprocess.interface';
import { SettlementProcessList } from '../_models/settlementprocesslist.interface';
import { AppConfig } from '../_helpers/appconfig.service';
import { map } from 'rxjs/operators';
import { CustomerReportExport } from '../_models/customerReportExport.interface';

@Injectable()
export class SettlementProcessService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions: any;

    constructor(protected httpClient: HttpClient
    ) {
    }//end const




    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }//end

    /**
     * get_settlement
     * Settlement
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public getSettlement(publicId: string, limit?: number, start?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getSettlement.');
        }

        let queryParameters = new HttpParams();

        if (limit !== undefined && limit !== null && limit !== 0 && limit.toString() !== '') {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        if (start !== undefined && start !== null && start.toString() !== '') {
            queryParameters = queryParameters.set('start', <any>start);
        }

        return this.httpClient.get<SettlementProcess>(`${this._kcmssvcURL}/settlement_process/${encodeURIComponent(String(publicId))}`,
            {
                params: queryParameters
            }
        );
    }//end

    /**
     * get_settlement_process_list
     * Get Settlement Process List
     * @param accountId
     * @param status
     * @param date
     * @param limit
     * @param start
     * @param end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public getSettlementProcessList(accountId: string, status?: string, date?: string, limit?: number, start?: number, end?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        return this.httpClient.get<SettlementProcessList>(`${this._kcmssvcURL}/settlements?account_id=` + encodeURIComponent(String(accountId)) + `&status=all`,
            {

            }
        );
    }//end



    /**
    * getSettlementReportList
    * Get getSettlement Report List
    * @param accountId
    * @param status
    * @param date
    * @param limit
    * @param start
    * @param end
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public getSettlementReportList(publicId: string, status?: string, from_date?: string, to_date?: string, limit?: number, start?: number, search?: string, filterBy?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter customer public Id was null or undefined when calling to get payments List.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
            queryParameters = queryParameters.set('from_date', <any>from_date);
        }

        if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
            queryParameters = queryParameters.set('to_date', <any>to_date);
        }

        if (limit !== undefined && limit !== null && limit !== 0 && limit.toString() !== '') {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (start !== undefined && start !== null && start.toString() !== '') {
            queryParameters = queryParameters.set('start', <any>start);
        }

        if (status !== undefined) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }

        if (filterBy == 2) {
            queryParameters = queryParameters.set('search_by', <any>'TRANSFER');
        }

        return this.httpClient.get<Array<SettlementProcessList>>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/settlements`,
            {
                params: queryParameters
                , withCredentials: null,

                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    getConfigurationDetails(publicId: string):Observable<any>{
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter customer public Id was null or undefined when calling to get configuration details.');
        }
        return this.httpClient.get<any>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/settlement.properties`).pipe(map(res => res)
        );
    }

    getVersionConfigurationDetails(publicId: string){
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter customer public Id was null or undefined when calling to get version configuration details.');
        }
        return this.httpClient.get<any>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/settlement_process.setup`).toPromise();
    }

    exportAsTXT(publicId: string, body: any) {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter public Id was null or undefined');
        }

        return this.httpClient.post<any>(`${this._kcmssvcURL}/settlement_process/${encodeURIComponent(String(publicId))}/export`, body,
            {
                observe: 'response',
            }
        );
    }

    multipleExportAsTXT(body: any) {
        return this.httpClient.post<any>(`${this._kcmssvcURL}/settlement_process/export`, body,
            {
                observe: 'response',
            }
        );
    }

    multipleExportAsXLSX(publicId: string, status?: string, from_date?: string, to_date?: string, limit?: number, start?: number, search?: string, filterBy?: number): Observable<CustomerReportExport> {
      if (publicId === null || publicId === undefined) {
          throw new Error('Required parameter customer public Id was null or undefined when calling to get payments List.');
      }

      let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

      if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
          queryParameters = queryParameters.set('from_date', <any>from_date);
      }

      if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
          queryParameters = queryParameters.set('to_date', <any>to_date);
      }

      if (limit !== undefined && limit !== null && limit !== 0 && limit.toString() !== '') {
          queryParameters = queryParameters.set('limit', <any>limit);
      }
      if (start !== undefined && start !== null && start.toString() !== '') {
          queryParameters = queryParameters.set('start', <any>start);
      }

      if (status !== undefined) {
          queryParameters = queryParameters.set('status', <any>status);
      }

      if (search !== undefined && search !== null && search !== '') {
          queryParameters = queryParameters.set('search', <any>search);
      }

      if (filterBy == 2) {
          queryParameters = queryParameters.set('search_by', <any>'TRANSFER');
      }

      return this.httpClient.get<CustomerReportExport>(`${this._kcmssvcURL}/customers/${publicId}/settlements/export`, {params: queryParameters, observe: 'body'}
    );
  }

}//end class
